// ✅ print-bridge.js
// 專門做環境偵測，根據平台載入對應印表機模組

let printerApi = {}; // 記錄已載入的模組
let ready = false; // 防止重複載入模組

// ✅ 判斷是否為平板或手機裝置
function isTabletDevice() {
  return /Android|iPhone|iPad|Tablet/i.test(navigator.userAgent);
}

// ✅ 初始化模組（僅執行一次）
async function init() {
  if (ready) return printerApi; // 若已初始化過，直接回傳

  if (isTabletDevice()) {
    console.log("[print-bridge] 偵測為手機/平板，載入 print.js");
    printerApi = await import("@/assets/Js/print.js"); // 📲 手機模組
  } else {
    console.log("[print-bridge] 偵測為 Windows，載入 print-win.js");
    printerApi = await import("@/assets/Js/print-win.js"); // 🖥️ Windows 模組
  }

  ready = true;
  return printerApi;
}

// ✅ 封裝 export，所有功能都會自動等模組載入
export default {
  async scanNetworkDevices(...args) {
    const api = await init();
    return api.scanNetworkDevices?.(...args) || api.scanDevices?.(...args);
  },
  async getNetworkInfo(...args) {
    const api = await init();
    return api.getNetworkInfo?.(...args);
  },
  async testPrinterConnection(...args) {
    const api = await init();
    return api.testPrinterConnection?.(...args) || api.testPrinter?.(...args);
  },
  async beepPrinter(...args) {
    const api = await init();
    return api.beepPrinter?.(...args);
  },
  async checkNativeCapabilities() {
    const api = await init();
    return (
      api.checkNativeCapabilities?.() || {
        isNativeApp: false,
        platform: isTabletDevice() ? "tablet" : "web",
        networkScan: false,
        printerTest: false,
        printing: false,
        networkInfo: false,
      }
    );
  },
  async waitForPrinterPlugin(...args) {
    const api = await init();
    return api.waitForPrinterPlugin?.(...args) || false;
  },
  async diagnoseSystem(...args) {
    const api = await init();
    return api.diagnoseSystem?.(...args) || {};
  },
  async printRaw(...args) {
    const api = await init();
    return (
      api.printRaw?.(...args) || { success: false, error: "printRaw 未實作" }
    );
  },

  async printInvoice(...args) {
    const api = await init();
    return (
      api.printInvoice?.(...args) || {
        success: false,
        error: "printInvoice 未實作",
      }
    );
  },

  async printMenuWithQR(...args) {
    const api = await init();
    return (
      api.printMenuWithQR?.(...args) || {
        success: false,
        error: "printMenuWithQR 未實作",
      }
    );
  },
};
